/**
 * Shared helper: POST a deal note; on failure enqueue to CRM sync outbox.
 * Returns true if sent immediately, false if queued.
 */
import { apiUrl } from "@/lib/api-client";
import { enqueueCrmSyncOp } from "@/lib/crm-sync-outbox";

export async function postDealNoteWithOutbox(dealId: string, body: string): Promise<boolean> {
  const clientMutationId = crypto.randomUUID();
  try {
    const r = await fetch(apiUrl(`/api/crm/deals/${dealId}/notes`), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ body, clientMutationId }),
    });
    if (!r.ok) {
      await enqueueCrmSyncOp("note", dealId, { body, clientMutationId });
      return false;
    }
    return true;
  } catch {
    await enqueueCrmSyncOp("note", dealId, { body, clientMutationId });
    return false;
  }
}
